<lib-header [logoSrc]="logo"></lib-header>
<lib-banner></lib-banner>
<main [style.background-color]="backgroundColor" >
    <router-outlet>
        <div class="loading-spinner" 
            [ngClass]="{ 'active': spinnerStore.isLoading()}">
            <lib-loading-spinner></lib-loading-spinner>
        </div>
    </router-outlet>
</main>
<lib-footer [companyName]="siteName"></lib-footer>